@if (initialized && scheduleType) {
  <div class="text-center mb-4">
    <div class="mb-4">
      <img
        *ngIf="qrCodeImageSrc; else placeholder"
        [src]="qrCodeImageSrc"
        alt="vCard QR Code"
        style="width: 180px; height: auto;"/>

      <ng-template #placeholder>
        <p class="text-color-secondary">QR-Code ist nicht verfügbar.</p>
      </ng-template>
    </div>

    <div class="text-color text-2xl font-semibold mb-2">Meine digitale Visitenkarte</div>
    <span class="text-color-secondary text-base">Scanne den QR-Code, um meine Kontaktdaten zu speichern.</span>
  </div>

}
